/* =============================================================================
   marco.js — Reloj del header (fecha sobre hora)
   Hotel La Gruta · Arequipa · estilos: "MARCO" en assets/css/site.css

   Muestra la hora de AREQUIPA (America/Lima, sin horario de verano), no la del
   visitante: es la hora a la que llegaría y a la que le contestaría el hotel.
   El formato sigue el idioma activo del sitio (ES/EN, ver i18n.js).

   Cuesta casi nada: un solo timeout alineado al cambio de minuto (no un
   setInterval de 1 s), que se pausa con la pestaña oculta y se reanuda al
   volver. Escribe dos nodos de texto; no toca el layout (el reloj tiene ancho
   fijo con cifras tabulares) ni se anima.
   ============================================================================= */
(function () {
  'use strict';

  var dateEl = document.getElementById('hdr-date');
  var timeEl = document.getElementById('hdr-time');
  if (!dateEl || !timeEl) return;

  var TZ = 'America/Lima';
  var LOCALES = { es: 'es-PE', en: 'en-US' };
  var timer = 0, fmtDate = null, fmtTime = null;

  function lang() { return (window.I18N && window.I18N.getLang && window.I18N.getLang()) || 'es'; }

  function build() {
    var loc = LOCALES[lang()] || LOCALES.es;
    try {
      fmtDate = new Intl.DateTimeFormat(loc, { timeZone: TZ, weekday: 'short', day: 'numeric', month: 'short' });
      fmtTime = new Intl.DateTimeFormat(loc, { timeZone: TZ, hour: 'numeric', minute: '2-digit' });
    } catch (e) { fmtDate = fmtTime = null; }   // navegador sin Intl con zona: el reloj queda vacío, sin romper nada
  }

  function pinta() {
    if (!fmtDate) return;
    var ahora = new Date();
    // es-PE escribe "jue, 2 oct": se quita la coma y el punto final de la
    // abreviatura para que lea limpio en mayúsculas ("JUE 2 OCT").
    dateEl.textContent = fmtDate.format(ahora).replace(/[,.]/g, '');
    timeEl.textContent = fmtTime.format(ahora);
    timeEl.setAttribute('datetime', ahora.toISOString());
  }

  function agenda() {
    clearTimeout(timer);
    if (document.hidden) return;
    pinta();
    var ms = 60000 - (Date.now() % 60000) + 50;   // justo después del próximo cambio de minuto
    timer = setTimeout(agenda, ms);
  }

  build();
  agenda();
  document.addEventListener('visibilitychange', agenda);
  document.addEventListener('i18n:change', function () { build(); pinta(); });
})();

/* «Cómo llegar»: en iPhone y iPad abre Mapas de Apple con la ruta; en lo
   demás (Android, escritorio) se queda en Google Maps. Solo cambia el enlace,
   así que sin JavaScript sigue llevando a Google Maps. */
(function () {
  'use strict';
  var esApple = /iPhone|iPad|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!esApple) return;
  document.querySelectorAll('a[href*="google.com/maps/dir/"]').forEach(function (a) {
    a.href = 'https://maps.apple.com/?daddr=-16.387764,-71.530067&dirflg=d';
  });
})();
